import { render } from "./ConfirmChangeEmail.vue?vue&type=template&id=ff87c3c8"
import script from "./ConfirmChangeEmail.vue?vue&type=script&lang=js"
export * from "./ConfirmChangeEmail.vue?vue&type=script&lang=js"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__